// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"2feb4e42","280":"2feb4e42","354":"2feb4e42","445":"fe01730a","548":"92e21ded","619":"2feb4e42","654":"8987a610","667":"31d6cfe0","820":"2feb4e42"}[chunkId] + ".chunk.css";
};